/**
 * Autodesk OAuth 2.0 configuration (public client, no client_secret).
 * Prefer REACT_APP_* env vars; fallbacks for local development.
 */

export const AUTODESK_AUTHORIZE_URL =
  process.env.REACT_APP_AUTODESK_AUTHORIZE_URL ||
  "https://developer.api.autodesk.com/authentication/v2/authorize";

export const AUTODESK_TOKEN_URL =
  process.env.REACT_APP_AUTODESK_TOKEN_URL ||
  "https://developer.api.autodesk.com/authentication/v2/token";

/** Must be from an APS app of type "Desktop, Mobile, Single-Page Web App" (PKCE). */
export const CLIENT_ID =
  process.env.REACT_APP_AUTODESK_CLIENT_ID || "";

export const REDIRECT_URI =
  process.env.REACT_APP_AUTODESK_REDIRECT_URI ||
  (typeof window !== "undefined"
    ? `${window.location.origin}/auth/callback`
    : "");

export const SCOPES =
  process.env.REACT_APP_AUTODESK_SCOPES || "data:read";

/** sessionStorage keys for PKCE (cleared after use) */
export const STORAGE_KEYS = {
  CODE_VERIFIER: "autodesk_code_verifier",
  STATE: "autodesk_state",
  TOKENS: "autodesk_tokens",
};
